import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_ea65263c from 'nuxt_plugin_workbox_ea65263c' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_6de0d3c2 from 'nuxt_plugin_nuxticons_6de0d3c2' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_sentryserver_5bab4b0a from 'nuxt_plugin_sentryserver_5bab4b0a' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_141c4cfc from 'nuxt_plugin_sentryclient_141c4cfc' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_vuetify_9d8a1e24 from 'nuxt_plugin_vuetify_9d8a1e24' // Source: ./vuetify.js (mode: 'all')
import nuxt_plugin_pluginrouting_6a6925c0 from 'nuxt_plugin_pluginrouting_6a6925c0' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_bc30c4a2 from 'nuxt_plugin_pluginmain_bc30c4a2' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_portalvue_4eaed266 from 'nuxt_plugin_portalvue_4eaed266' // Source: ./portal-vue.js (mode: 'all')
import nuxt_plugin_libplugin5967b9bc_7fc936ed from 'nuxt_plugin_libplugin5967b9bc_7fc936ed' // Source: ./lib.plugin.5967b9bc.js (mode: 'all')
import nuxt_plugin_voicerconfiguratorplugina1adfa22_7f27b310 from 'nuxt_plugin_voicerconfiguratorplugina1adfa22_7f27b310' // Source: ./voicer-configurator.plugin.a1adfa22.ejs (mode: 'all')
import nuxt_plugin_globalcomponents_71e0727c from 'nuxt_plugin_globalcomponents_71e0727c' // Source: ./global-components.js (mode: 'all')
import nuxt_plugin_spoke_33727654 from 'nuxt_plugin_spoke_33727654' // Source: ../plugins/spoke (mode: 'all')
import nuxt_plugin_injector_03ffdcaa from 'nuxt_plugin_injector_03ffdcaa' // Source: ../plugins/injector (mode: 'all')
import nuxt_plugin_tracking_31194aaa from 'nuxt_plugin_tracking_31194aaa' // Source: ../plugins/tracking.js (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Bubblecast","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, minimal-ui, shrink-to-fit=no"},{"hid":"description","name":"description","content":"Tous vos podcasts privés, au même endroit"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"http-equiv":"X-UA-Compatible","content":"IE=edge"},{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"robots","name":"robots","content":"index,follow"},{"hid":"ogSiteName","name":"og:site_name","content":"Bubblecast"},{"hid":"ogType","name":"og:type","content":"website"},{"name":"msapplication-config","content":"\u002Fbrowserconfig.xml"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"Giphar Info"},{"hid":"author","name":"author","content":"Mediameeting"},{"hid":"theme-color","name":"theme-color","content":"#75b72f"},{"hid":"og:title","name":"og:title","property":"og:title","content":"Giphar Info"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Voice business application by Mediameeting"}],"script":[{"rel":"preload","crossorigin":"crossorigin","src":"https:\u002F\u002Fpolyfill.io\u002Fv3\u002Fpolyfill.js?features=es5,es6,es7,es2017,fetch,IntersectionObserver,Object.entries,Object.values&flags=gated","body":true}],"link":[{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.a478fd9f.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64x64.702618.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512x512.702618.png","sizes":"512x512"}],"style":[{"innerHTML":"@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Fmaterialicons\u002Fv70\u002FflUhRq6tzZclQEJ-Vdg-IuiaDsNZ.ttf) format('truetype');\n  font-display: swap; \n}\n@font-face {\n  font-family: 'Merriweather';\n  font-style: normal;\n  font-weight: 300;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Fmerriweather\u002Fv22\u002Fu-4n0qyriQwlOrhSvowK_l521wRpXw.ttf) format('truetype');\n  font-display: swap; \n}\n@font-face {\n  font-family: 'Merriweather';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Fmerriweather\u002Fv22\u002Fu-440qyriQwlOrhSvowK_l5Oew.ttf) format('truetype');\n  font-display: swap; \n}\n@font-face {\n  font-family: 'Merriweather';\n  font-style: normal;\n  font-weight: 700;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Fmerriweather\u002Fv22\u002Fu-4n0qyriQwlOrhSvowK_l52xwNpXw.ttf) format('truetype');\n  font-display: swap; \n}\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 300;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Froboto\u002Fv20\u002FKFOlCnqEu92Fr1MmSU5vAw.ttf) format('truetype');\n  font-display: swap; \n}\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Froboto\u002Fv20\u002FKFOmCnqEu92Fr1Me5Q.ttf) format('truetype');\n  font-display: swap; \n}\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 500;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Froboto\u002Fv20\u002FKFOlCnqEu92Fr1MmEU9vAw.ttf) format('truetype');\n  font-display: swap; \n}\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-weight: 700;\n  src: url(\u002Ffonts\u002Fgoogle\u002Fs\u002Froboto\u002Fv20\u002FKFOlCnqEu92Fr1MmWUlvAw.ttf) format('truetype');\n  font-display: swap; \n}\n\n.material-icons {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  line-height: 1;\n  letter-spacing: normal;\n  text-transform: none;\n  display: inline-block;\n  white-space: nowrap;\n  word-wrap: normal;\n  direction: ltr;\n  font-display: swap; \n}\n"}],"htmlAttrs":{"lang":"fr-FR"}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_ea65263c === 'function') {
    await nuxt_plugin_workbox_ea65263c(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_6de0d3c2 === 'function') {
    await nuxt_plugin_nuxticons_6de0d3c2(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_5bab4b0a === 'function') {
    await nuxt_plugin_sentryserver_5bab4b0a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_141c4cfc === 'function') {
    await nuxt_plugin_sentryclient_141c4cfc(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_9d8a1e24 === 'function') {
    await nuxt_plugin_vuetify_9d8a1e24(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_6a6925c0 === 'function') {
    await nuxt_plugin_pluginrouting_6a6925c0(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_bc30c4a2 === 'function') {
    await nuxt_plugin_pluginmain_bc30c4a2(app.context, inject)
  }

  if (typeof nuxt_plugin_portalvue_4eaed266 === 'function') {
    await nuxt_plugin_portalvue_4eaed266(app.context, inject)
  }

  if (typeof nuxt_plugin_libplugin5967b9bc_7fc936ed === 'function') {
    await nuxt_plugin_libplugin5967b9bc_7fc936ed(app.context, inject)
  }

  if (typeof nuxt_plugin_voicerconfiguratorplugina1adfa22_7f27b310 === 'function') {
    await nuxt_plugin_voicerconfiguratorplugina1adfa22_7f27b310(app.context, inject)
  }

  if (typeof nuxt_plugin_globalcomponents_71e0727c === 'function') {
    await nuxt_plugin_globalcomponents_71e0727c(app.context, inject)
  }

  if (typeof nuxt_plugin_spoke_33727654 === 'function') {
    await nuxt_plugin_spoke_33727654(app.context, inject)
  }

  if (typeof nuxt_plugin_injector_03ffdcaa === 'function') {
    await nuxt_plugin_injector_03ffdcaa(app.context, inject)
  }

  if (typeof nuxt_plugin_tracking_31194aaa === 'function') {
    await nuxt_plugin_tracking_31194aaa(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
